import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export default function AdminVerify() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    if (!token) { setError("This sign-in link is invalid."); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/admin/verify", { token });
        setUser(data);
        navigate("/admin");
      } catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    })();
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#141312] px-6">
      {error ? (
        <div className="text-center max-w-sm">
          <p className="eyebrow text-vermilion mb-3">Sign-In Failed</p>
          <p className="font-serif text-2xl text-ivory">{error}</p>
          <button onClick={() => navigate("/admin/login")} className="mt-6 text-xs font-mono uppercase tracking-[0.2em] text-champagne border-b border-champagne pb-1">Return to Portal</button>
        </div>
      ) : (
        <div className="font-serif text-2xl tracking-[0.3em] text-linen/60 animate-pulse">VERIFYING</div>
      )}
    </div>
  );
}
